import { unformatSsn } from 'src/lib/ssn.utils'

import { toApplicationPayload } from '../employment/lib/formBridge'

import type { generateInitialValues } from './form'

type FormValues = ReturnType<typeof generateInitialValues>

const toDate = (value: unknown) => new Date(value as string)

export const buildNamePayload = (values: FormValues) => ({
  firstName: values.firstName,
  middleName: values.middleName,
  lastName: values.lastName,
})

export const buildPersonalDetailsPayload = (values: FormValues) => ({
  email: values.email,
  dob: toDate(values.dob),
  issuingCountry: values.issuingCountry,
  ssn: unformatSsn(values.ssn),
  availableForWork: toDate(values.availableForWork),
  yearsOfExperience: parseFloat(String(values.yearsOfExperience)),
})

export const buildAddressesPayload = (values: FormValues) => ({
  addresses: (values.addresses ?? []).map((address) => {
    const { id: _id, ...rest } = address as typeof address & { id?: string }
    return rest
  }),
})

export const buildLicensePayload = (values: FormValues) => ({
  license: { ...values.license },
  twicCard: { ...values.twicCard },
  previousLicenses: (values.previousLicenses ?? []).map((license) => {
    const { id, ...rest } = license
    return { ...rest, ...(id && { licenseId: id }) }
  }),
})

export const buildEquipmentPayload = (values: FormValues) => ({
  equipment: (values.equipment ?? []).map((element) => ({
    ...element,
    year: parseInt(element.year ?? ''),
    weight: parseFloat(element.weight ?? ''),
    mileage: parseFloat(element.mileage ?? ''),
    fifthWheelHeightInches: parseFloat(element.fifthWheelHeightInches ?? ''),
  })),
})

export const buildAccidentsPayload = (values: FormValues) => ({
  accidents: (values.accidents ?? []).map((accident) => {
    const { key: _key, ...rest } = accident
    return rest
  }),
})

export const buildEmploymentPayload = (values: FormValues) =>
  toApplicationPayload(values.employmentExperiences ?? [])
